import {computed, Injectable, Signal, signal, WritableSignal,} from '@angular/core';
import {PlatformService} from '../../../core/services/platform-service/platform.service';
import {AppInterface, ETileType,} from '../../../core/interfaces/app.interface';
import {FolderUiService} from './folder-ui.service';
import {FolderInterface} from '../../../core/interfaces/folder.interface';
import {AppInstanceAPIService} from '../../../core/services/appinstance-service/appinstance.service';
import {CdkDragMove} from '@angular/cdk/drag-drop';

@Injectable({
  providedIn: 'root',
})
export class WidgetUIService {
  N_ADDITIONAL_CELLS = 30;
  public apps: WritableSignal<AppInterface[]> = signal([]);

  public appsInFolder: Signal<AppInterface[]> = computed(() =>
    this.apps().filter(
      (_app) =>
        _app.inDashboard &&
        _app.folderId === this.folderUIService.getSelectedFolder()()?.id,
    )
      .sort((_a, _b) => _a.posX! - _b.posX!),
  );

  public mobileApps: Signal<AppInterface[]> = computed(() =>
    this.appsInFolder()
      .filter((_app) => _app.supportsMobile)
      .sort((_a, _b) => _a.posX! - _b.posX!),
  );

  constructor(
    private readonly platformService: PlatformService,
    private readonly folderUIService: FolderUiService,
    private readonly appInstanceService: AppInstanceAPIService,
  ) {
  }

  public isSmall(_app: AppInterface): boolean {
    return (
      this.platformService.isMobile() ||
      _app.appType === ETileType.Static ||
      _app.appType === ETileType.Card
    );
  }

  updateWidgetPosition(_app: AppInterface, _newPos: number) {
    this.apps.update((_apps) => {
      const appToMutate = _apps.find(
        (_appInArray) => _appInArray.appInstanceId === _app.appInstanceId,
      ) as AppInterface;
      appToMutate.posX = _newPos;
      return [..._apps];
    });
  }

  updateWidgetFolder(_app: AppInterface, _newFolder: FolderInterface) {
    this.apps.update((_apps) => {
      const appToMutate = _apps.find(
        (_appInArray) => _appInArray.appInstanceId === _app.appInstanceId,
      ) as AppInterface;
      appToMutate.folderId = _newFolder.id;
      return [..._apps];
    });
  }

  forceAllAppsSignalRecomputation(): void {
    this.apps.update((_apps) => [..._apps]);
  }

  getAppsInFolder(folderId: string): AppInterface[] {
    return this.apps().filter(
      (app) => app.inDashboard && app.folderId === folderId,
    );
  }

  rearrangeGridLayout(appInstanceIds: string[]) {

    return this.appInstanceService.rearrangeGridLayout(appInstanceIds);

  }

  public scrollWidgetIfOutsideView(_e: CdkDragMove<AppInterface>) {
    const container = document.querySelector('.grid-container') as HTMLElement;

    if (!container) {
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const pointerPosition = _e.pointerPosition;
    const scrollMargin = 200; // Pixels near the edges where scrolling should start
    const scrollStep = 30; // Speed of scrolling (pixels per event)

    // Check if we should scroll the container up
    if (pointerPosition.y < containerRect.top + scrollMargin) {
      container.scrollTop -= scrollStep;
    } // Check if we should scroll the container down
    if (pointerPosition.y > containerRect.bottom - scrollMargin) {
      container.scrollTop += scrollStep;
    }
  }
}
